import { AFFECTED_URL_EXPORT_TOO_LARGE, AFFECTED_URL_EXPORT_TOO_LARGE_MESSAGE } from '@prerender/diagnostics-api';
import { Alert, Button } from 'react-bootstrap';

import DownloadIcon from './DownloadIcon';
import { useExportAffectedUrlsMutation } from './incidentsApi';

type AffectedUrlsExportProps = {
  reference: string;
};

const EXPORT_LABEL = 'Export CSV';
const PREPARING_LABEL = 'Preparing…';
const FAILED_MESSAGE = 'The export failed. Try again.';

const UNPROCESSABLE = 422;

function isTooLarge(error: unknown): boolean {
  const { status, data } = error as { status?: unknown; data?: { reason?: unknown } };

  return status === UNPROCESSABLE && data?.reason === AFFECTED_URL_EXPORT_TOO_LARGE;
}

function AffectedUrlsExport({ reference }: AffectedUrlsExportProps): JSX.Element {
  const [exportAffectedUrls, { isLoading, error }] = useExportAffectedUrlsMutation();

  const onExport = (): void => {
    void exportAffectedUrls(reference);
  };

  return (
    <div className="diagnostics-affected-url-export">
      <Button variant="outline-secondary" onClick={onExport} disabled={isLoading}>
        <DownloadIcon /> {isLoading ? PREPARING_LABEL : EXPORT_LABEL}
      </Button>
      {error !== undefined && (
        <Alert variant="danger" className="diagnostics-affected-url-export-error">
          {isTooLarge(error) ? AFFECTED_URL_EXPORT_TOO_LARGE_MESSAGE : FAILED_MESSAGE}
        </Alert>
      )}
    </div>
  );
}

export default AffectedUrlsExport;
